import { useReactiveVar } from '@apollo/client/react';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import CloseIcon from '@mui/icons-material/Close';
import React, { type FC } from 'react';
import { snackBarVar } from '../../../graphql/local/snackBar/vars';

const GlobalSnackBar: FC = () => {
  const snackBarData = useReactiveVar(snackBarVar);
  const { message, type, isOpen, duration } = snackBarData;

  const handleClose = () => {
    snackBarVar({ ...snackBarData, isOpen: false });
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isOpen}
      autoHideDuration={duration!}
      onClose={handleClose}
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="primary"
          onClick={handleClose}
          size="large"
        >
          <CloseIcon />
        </IconButton>,
      ]}
    >
      <SnackbarContent
        onClick={handleClose}
        message={message}
        style={{
          backgroundColor: type === 'SUCCESS' ? '#2bc93a' : 'red',
          fontSize: 14,
          zIndex: 9,
        }}
      />
    </Snackbar>
  );
};

export default GlobalSnackBar;
